import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'
// 用户列表
export const apiUserinfoList = data => {
  return axios.request({
    url: '/userinfo/list',
    method: 'post',
    data
  })
}

// 改变推广状态
export const apiUpdateAgentType = data => {
  return axios.request({
    url: '/userinfo/change-agent-type',
    method: 'post',
    data
  })
}

// 改变推广状态
export const apiChangeReferStatus = data => {
  return axios.request({
    url: '/userinfo/change-refer-status',
    method: 'post',
    data
  })
}
// 改变推广状态
export const apiRecommendImgByUserId = data => {
  return axios.request({
    url: 'https://api.dianggg.com/recommon-img-by-userId',
    method: 'get',
    data
  })
}
//   积分记录列表
export const apiScoredetailList = data => {
  return axios.request({
    url: '/scoredetail/list',
    method: 'post',
    data
  })
}

// /用户导出
export const apiUserinfoExport = data => {
  return fileAxios.request({
    url: '/userinfo/export',
    method: 'get',
    data
  }, { responseType: 'blob' })
}
